<template>
  <div
    class="kd"
    :class="{
      'kd--print': IS_PRINT_MODE,
      'kd--screenshot': IS_SCREENSHOT_MODE,
    }"
    :style="{
      height: `${WINDOW_HEIGHT}px`,
    }"
    v-if="KARTENDESIGNER_VISIBLE"
  >
    <div class="kd__content">
      <kd-logo></kd-logo>
      <kd-card></kd-card>
      <kd-close-button
        v-if="!IS_PRINT_MODE && !LAYOUT_MODE_ACTIVE"
      ></kd-close-button>
      <kd-sidebar-icons
        v-if="!IS_PRINT_MODE && !LAYOUT_MODE_ACTIVE"
      ></kd-sidebar-icons>
      <kd-scale-buttons></kd-scale-buttons>
      <kd-thumbnails v-if="!IS_PRINT_MODE"></kd-thumbnails>
      <kd-action-buttons
        v-if="!IS_PRINT_MODE && !LAYOUT_MODE_ACTIVE"
      ></kd-action-buttons>
      <kd-layout-buttons
        v-if="!IS_PRINT_MODE && LAYOUT_MODE_ACTIVE"
      ></kd-layout-buttons>
      <kd-action-buttons-layout
        v-if="!IS_PRINT_MODE && LAYOUT_MODE_ACTIVE"
      ></kd-action-buttons-layout>
      <kd-layer-settings
        v-if="!IS_PRINT_MODE && !LAYOUT_MODE_ACTIVE"
      ></kd-layer-settings>
      <kd-tooltip-overlay v-if="!IS_PRINT_MODE"></kd-tooltip-overlay>
      <kd-preview v-if="!IS_PRINT_MODE"></kd-preview>
      <kd-checkout-loader v-if="WAITING_FOR_PDF"></kd-checkout-loader>
      <kd-unsupported-device-warning
        :width="WINDOW_WIDTH"
        :height="WINDOW_HEIGHT"
      ></kd-unsupported-device-warning> 
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import KdCloseButton from '@/components/KdCloseButton.vue';
import KdSidebarIcons from '@/components/KdSidebarIcons.vue';
import KdCard from '@/components/KdCard.vue';
import KdThumbnails from '@/components/KdThumbnails.vue';
import KdActionButtons from '@/components/KdActionButtons.vue';
import KdActionButtonsLayout from '@/components/KdActionButtonsLayout.vue';
import KdLayoutButtons from '@/components/KdLayoutButtons';
import KdLayerSettings from '@/components/KdLayerSettings.vue';
import KdTooltipOverlay from '@/components/KdTooltipOverlay.vue';
import KdPreview from '@/components/KdPreview.vue';
import KdCheckoutLoader from '@/components/KdCheckoutLoader.vue';
import KdUnsupportedDeviceWarning from '@/components/KdUnsupportedDeviceWarning.vue';
import KdScaleButtons from '@/components/KdScaleButtons.vue';
import KdLogo from '@/components/KdLogo.vue';

import {
  KARTENDESIGNER_VISIBLE,
  IS_PRINT_MODE,
  IS_SCREENSHOT_MODE,
  WAITING_FOR_PDF,
  LAYOUT_MODE_ACTIVE,
  WINDOW_WIDTH,
  WINDOW_HEIGHT,
} from '@/store/getter-types';

import {
  SET_WINDOW_DIMENSIONS,
} from '@/store/mutation-types';

export default {
  name: 'kartendesigner',
  computed: {
    ...mapGetters([
      KARTENDESIGNER_VISIBLE,
      IS_PRINT_MODE,
      IS_SCREENSHOT_MODE,
      WAITING_FOR_PDF,
      LAYOUT_MODE_ACTIVE,
      WINDOW_WIDTH,
      WINDOW_HEIGHT,
    ]),
    // isUnsupportedDevice() {
    //   return this.WINDOW_WIDTH < 1024 || this.WINDOW_HEIGHT < 600;
    // },
  },
  methods: {
    ...mapMutations([
      SET_WINDOW_DIMENSIONS,
    ]),
    handleResize() {
      // const width = window.innerWidth; // wrong values after device rotate on iOS Chrome
      // const height = window.innerHeight;
      const width = document.documentElement.clientWidth;
      const height = document.documentElement.clientHeight;
      this.SET_WINDOW_DIMENSIONS({ width, height });
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    window.addEventListener("orientationchange", this.handleResize);
    this.handleResize(); // must be called once to set the proper dimensions on start up
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("orientationchange", this.handleResize);
  },
  components: {
    KdCloseButton,
    KdSidebarIcons,
    KdCard,
    KdThumbnails,
    KdActionButtons,
    KdActionButtonsLayout,
    KdLayoutButtons,
    KdLayerSettings,
    KdTooltipOverlay,
    KdPreview,
    KdCheckoutLoader,
    KdUnsupportedDeviceWarning,
    KdScaleButtons,
    KdLogo,
  },
};
</script>

<style lang="scss">
@import '@/shared/scss/webfonts.scss';
@import '@/scss/kd-tooltip.scss';

.kd {
  width: 100vw;
  // on iOS this is wrong. Element is 100vh AFTER scrolling,
  // when the scroll bar disappeared. As the kartendesigner is non-scolling,
  // we cannot use 100vh on iOS, therefore we need to set it via javascript.
  // height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 1.0);
  color: #333;
  padding: 12px;
  font-family: 'Open Sans', sans-serif;
  z-index: 100000;

  // make sure only the card is visible in print mode
  // and that it is centered on the page
  &--print {
    padding: 0;
    background-color: #FFFFFF;
  }
  // when screenshots are taken (for preview images, as well as for the front
  // page of the final greeting card), this class is set.
  &--screenshot {}
}

.kd__close {
  position: absolute;
  top: 30px;
  right: 30px;
}

.kd__content {
  border-radius: 4px;
  background-color: #F5F5F5;
  width: 100%;
  height: 100%;
  position: relative;

  .kd--print & { // hode background in print mode
    background-color: transparent;
  }
}
</style>
